var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyLarge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.5H26C26.825 0.5 27.5 1.14286 27.5 1.92857V19.0714C27.5 19.8571 26.825 20.5 26 20.5H22.9075V8.35714C22.9075 7.57143 22.2325 6.92857 21.4075 6.92857H5.5V1.92857C5.5 1.14286 6.175 0.5 7 0.5ZM1.92857 9.5H19.0714C19.8604 9.5 20.5 10.1396 20.5 10.9286V28.0714C20.5 28.8604 19.8604 29.5 19.0714 29.5H1.92857C1.13959 29.5 0.5 28.8604 0.5 28.0714V10.9286C0.5 10.1396 1.13959 9.5 1.92857 9.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLarge);
export default __webpack_public_path__ + "static/media/copy-large.7929fdd8d2c354182c0dd743ffc47e86.svg";
export { ForwardRef as ReactComponent };